import { gql, useQuery } from "@apollo/client";
import {
  ViewCommunityEntityByIdQueryQuery,
  ViewCommunityEntityByIdQueryQueryVariables
} from "../../../../schemaTypes";

export const viewCommunityEntityByIdQuery = gql`
  query ViewCommunityEntityByIdQuery(
    $communityEntityId: String!
  ) {
    viewCommunityEntityById(
      communityEntityId: $communityEntityId
    ) {
      id
      name
      shortName,
      entityType,
      createdBy {
        id
        admin {
          id
          firstname
          lastname
          email
          level
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export function useViewCommunityEntity(communityEntityId: string) {
  const { data, loading, error } = useQuery<
    ViewCommunityEntityByIdQueryQuery,
    ViewCommunityEntityByIdQueryQueryVariables
  >(viewCommunityEntityByIdQuery, {
    variables: { communityEntityId },
    skip: !communityEntityId,
  });

  const communityEntityData = data?.viewCommunityEntityById;
  const communityEntity = Array.isArray(communityEntityData)
    ? communityEntityData[0]
    : communityEntityData;

  return {
    communityEntity,
    loading,
    error
  };
}
